import { faCheckCircle, faExclamationCircle, faWarning } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { setNotification } from "../../redux/notificationSlice"

export default function NotificationBanner() {
  const [showBanner, setShowBanner] = useState(false)
  const [messageIcon, setMessageIcon] = useState(faCheckCircle)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const notification = useSelector((state) => state.notification)

  // all unit in pixels (px)
  const defaultSlideUpAnimation = -344;
  const slideDownAnimation = 16;
  const itemHeight = 28;
  const maxContentHeight = 200;
  const itemCounts = notification.body?.props?.children.length || 1;
  const closeWithTimer = useRef(false)

  const getCurrentMaxHeight = () => {
    if (itemCounts > 1) {
      let sumOfAllItemsHeight = itemHeight * itemCounts
      if (sumOfAllItemsHeight < maxContentHeight) {
        return sumOfAllItemsHeight;
      } else {
        return maxContentHeight;
      }
    }
    //if no body message then reduce body height to 0
    if (notification?.body === "" || !notification.body || notification.body == null) {
      return 0
    } else {
      return itemHeight;
    }
  }

  const getSlideUpAnimation = () => {
    if (getCurrentMaxHeight() < maxContentHeight) {
      return defaultSlideUpAnimation + (maxContentHeight - getCurrentMaxHeight());
    }
    return defaultSlideUpAnimation;
  }

  useEffect(() => {
    if (notification.type) {
      switch (notification.type) {
        case 'success':
          setMessageIcon(faCheckCircle)
          break
        case 'error':
          setMessageIcon(faExclamationCircle)
          break
        case 'warning':
          setMessageIcon(faWarning)
          break
      }
      setShowBanner(true)
    }
  }, [notification.type])

  useEffect(() => {
    //we need to reset the timer when there is an error banner message and user click on the same button to popup the slightly differ error body.
    //if the body also same then, this reset fun will be ignored and will not reset the seconds.
    resetTimer()

    if (showBanner && (notification.type === 'success' || notification.type === 'warning')) {
      closeWithTimer.current = setTimeout(() => {
        setShowBanner(false)
        dispatchClose()
      }, 3000) // close in 3 seconds if success and waring
    }
    if (showBanner && (notification.type === 'error')) {
      closeWithTimer.current = setTimeout(() => {
        setShowBanner(false)
        dispatchClose()
      }, 8000) // close in 8 seconds if error
    }
  }, [showBanner, notification.body])

  const resetTimer = () => {
    if (closeWithTimer.current != false) {
      clearTimeout(closeWithTimer.current)
      closeWithTimer.current = false
    }
  }

  const closeNotificationBanner = () => {
    resetTimer()
    setShowBanner(false)
    dispatchClose()
  }

  const dispatchClose = () => {
    setTimeout(() => {
      dispatch(
        setNotification({ type: '', body: '' })
      )
    }, 500)
  }

  if (notification.type) {
    return (
      <span className="lox-notification-banner">
        <div
          className={`notification ${notification.type}_message lox-slide-up-notification`}
          data-testid={`notification-${notification.type}`}
          style={{ top: showBanner ? getSlideUpAnimation() : slideDownAnimation }}
        >
          <button
            className="delete"
            onClick={() => closeNotificationBanner()}
          ></button>
          <h3 className="title is-size-5 mb-1 is-capitalized">
            <FontAwesomeIcon icon={messageIcon} className="mr-2" />
            {notification.type}
          </h3>
          <span className="ml-5 is-size-6 is-flex is-justify-content-space-between error-container" style={{ maxHeight: getCurrentMaxHeight(), overflowY: 'scroll' }}>
            {notification.body}
            {notification.buttons.includes('retryCache') ? (
              <button
                className="button has-background-grey has-text-white is-small"
                onClick={() => {
                  localStorage.removeItem('persist:root')
                  navigate('/home')
                }}
              >
                Try Again
              </button>
            ) : ''}
          </span>
        </div>
      </span>
    )
  }
  return ''
}
